import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Container } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import AddVendor from '../../../../../ProgramOnboarding/Components/SelectVendor/Components/AddVendor';
import { isValidEmail } from '../../../../../../../../Helpers/Helpers';
import { useDispatch } from 'react-redux';
import { CREATE_VENDOR_V2, UPDATE_VENDOR_V2 } from '../../../../../../../../../store/actions';
import PartialVendorConfigure from '../../../../../ProgramOnboarding/Components/Comman/Modal/PartialVendorConfigure';
import { truncate } from 'lodash';
import { ChevronLeft } from 'react-feather';

const initialState = {
  id: '',
  name: '',
  email: '',
  documentUrl: '',
  region: null,
  currency: null,
  selectedCarTypes: [],
  carTypes: ['SUV', 'Sedan', 'Luxury', 'Luxury Suv', 'Luxury Sedan'],
};

const AddAndUpdateVendor = ({ currentSelectedInventory, onClose, isUpdate }) => {
  const dispatch = useDispatch();

  const [vendor, setVendor] = useState(initialState);
  const [errors, setErrors] = useState<any>({});
  const [isPartiallyVendorConfigureOpenModal, setIsPartiallyVendorConfigureOpenModal] = useState(false);
  const [isVendorFullConfigure, setIsVendorFullConfigure] = useState(false);
  const [car, setCar] = useState([
    {
      id: '',
      carName: '',
      carType: null,
    },
  ]);

  useEffect(() => {
    if (currentSelectedInventory) {
      setVendor({
        id: currentSelectedInventory?.id,
        name: `${currentSelectedInventory?.firstName ?? ''}`.trim(),
        email: currentSelectedInventory?.email ?? '',
        documentUrl: currentSelectedInventory?.documentUrl ?? '',
        region: currentSelectedInventory?.region ? { value: currentSelectedInventory?.region, label: currentSelectedInventory?.region } : null,
        currency: currentSelectedInventory?.currency
          ? { value: currentSelectedInventory?.currency, label: currentSelectedInventory?.currency }
          : null,
        selectedCarTypes: currentSelectedInventory?.carTypes ?? [],
      });
      const selectedCars =
        currentSelectedInventory?.carTypes?.flatMap(carType =>
          carType.cars.map(car => ({
            id: car?.carId,
            carName: car?.carName,
            carType: { value: carType?.name, label: carType?.name, data: carType }, // add carType info
          })),
        ) || [];

      setCar(selectedCars);
    }
  }, [currentSelectedInventory]);

  const validate = () => {
    const newErrors: any = {};
    if (!vendor.name.trim()) newErrors.name = 'Vendor Name is required';
    if (!vendor.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!isValidEmail(vendor.email.trim())) {
      newErrors.email = 'Invalid email format';
    }

    if (isVendorFullConfigure && !vendor.documentUrl) {
      newErrors.documentUrl = 'Document is required';
    }

    if (!vendor.region) newErrors.region = 'Region is required';
    if (!vendor.currency) newErrors.currency = 'Currency is required';
    if (vendor.selectedCarTypes.length === 0) newErrors.selectedCarTypes = 'Please select at least one car type';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleVendor = () => {
    if (validate() && isUpdate) {
      createVendor();
    } else if (validate() && !isVendorFullConfigure) {
      setIsPartiallyVendorConfigureOpenModal(true);
    } else if (validate()) {
      createVendor();
    }
  };

  const createVendor = () => {
    const payload = {
      name: vendor?.name ?? '',
      email: vendor?.email ?? '',
      documentUrl: vendor?.documentUrl ?? '',
      region: vendor?.region?.label ?? '',
      currency: vendor?.currency?.value ?? '',
      carTypes: vendor?.selectedCarTypes,
    };

    if (isUpdate) {
      dispatch({
        type: UPDATE_VENDOR_V2,
        payload: {
          data: { ...payload, id: currentSelectedInventory?.id },
        },
      });
    } else {
      dispatch({
        type: CREATE_VENDOR_V2,
        payload: {
          data: {
            ...payload,
            carTypes: vendor?.selectedCarTypes.map(carType => {
              const getCarsForCarType = car
                .filter(carItem => carType?.id === carItem?.carType?.value)
                ?.map(carItem => ({
                  carName: carItem?.carName,
                  ...(!carItem?.id && { tag: 'partially_configured' }),
                }));
              return {
                ...carType,
                cars: getCarsForCarType,
              };
            }),
          },
        },
      });
      setIsPartiallyVendorConfigureOpenModal(false);
    }
  };

  return (
    <Card className="p-3">
      {isPartiallyVendorConfigureOpenModal && (
        <PartialVendorConfigure
          onClose={() => {
            setIsPartiallyVendorConfigureOpenModal(false);
          }}
          handleYes={createVendor}
          handleNo={() => {
            setIsVendorFullConfigure(true);
            setIsPartiallyVendorConfigureOpenModal(false);
          }}
        />
      )}

      <CardHeader tag="h5" className="border-bottom pb-2">
        {isUpdate ? 'Update Vendor' : 'Add Vendor'}
      </CardHeader>
      <CardBody>
        <AddVendor
          vendor={vendor}
          setVendor={setVendor}
          errors={errors}
          setErrors={setErrors}
          state={null}
          isVendorFullConfigure={isVendorFullConfigure}
          isUpdate={isUpdate}
          existCarTypeOptionsForUpdate={vendor?.selectedCarTypes}
          car={car}
          setCar={setCar}
        />
        <div className="d-flex justify-content-between mt-4">
          <Button
            onClick={() => {
              setVendor(initialState);
              onClose();
            }}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{
              backgroundColor: '#E9EBEC', // light gray
              color: '#404B7C', // navy/dark blue
              fontWeight: 500,
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <ChevronLeft size={18} />
            Back
          </Button>

          <Button className="btn btn-primary" color="primary" onClick={handleVendor}>
            {isUpdate ? 'Update Vendor' : 'Add Vendor'}
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default AddAndUpdateVendor;
